import styled from 'styled-components'

export const FormContainer = styled.form<{ disabled?: boolean }>`
  width: 100%;
  max-width: 562.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 24px;
  gap: 40px;
  background: linear-gradient(
    180deg,
    rgba(8, 237, 220, 0.1) 0%,
    rgba(8, 237, 220, 0.15) 50%,
    rgba(8, 237, 220, 0.1) 100%
  );
  box-shadow: 0px 0px 18px rgba(8, 237, 220, 0.1);
  border-radius: 32px;

  .input-form {
    margin: 0;
    label {
      color: ${({ theme }) => theme.colors.primary};
    }
    input {
      border-color: ${({ theme }) => theme.colors.primary};
      color: ${({ theme }) => theme.colors.white};
    }
  }

  .button-container {
    width: 100%;
    max-width: 100%;
    button {
      width: 100%;
      max-width: 100%;
    }

    &:hover {
      width: ${(props) => (props.disabled ? '100%' : '90%')};
    }
  }
`
